<template>
    <cadastro-simples-form
        endpoint="tipo-ata"
        rota-base="/admin/tipo-ata"
        titulo-singular="Tipo de Ata"
        :campos-extras='[]'>
    </cadastro-simples-form>
</template>

<script>
import CadastroSimplesForm from '@/components/cadastros-auxiliares/cadastro-simples-form.vue'
export default { components: { CadastroSimplesForm } }
</script>
